const routes = [
  {
    path: '/term',
    name: 'Term',
    component: () => import(/* webpackChunkName: "term" */ '@/views/term/TermMain'),
    children: [
      {
        path: 'list',
        alias: '',
        name: 'TermList',
        component: () => import(/* webpackChunkName: "term" */ '@/views/term/TermList'),
        prop: true,
        meta: {
          step: ['단말기 설정', '단말기 설정 리스트(Term)']
        }
      },
      {
        path: ':seq(\\d+)',
        name: 'TermView',
        component: () => import(/* webpackChunkName: "term" */ '@/views/term/TermView'),
        prop: true,
        meta: {
          step: ['단말기 설정', '단말기 설정 세부(Term)']
        }
      },
      {
        path: 'write',
        name: 'TermWrite',
        component: () => import(/* webpackChunkName: "term" */ '@/views/term/TermView'),
        prop: true,
        meta: {
          step: ['단말기 설정', '단말기 설정 등록(Term)']
        }
      }
    ]
  }
]

export default routes
